import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75ef25fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "print-content" }
const _hoisted_2 = ["onClick", "onMousemove"]
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "article" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "article__header padding-for-logo" }
const _hoisted_7 = { class: "article__title" }
const _hoisted_8 = { class: "article__header" }
const _hoisted_9 = { class: "article__subtitle" }
const _hoisted_10 = ["data-id"]

import { computed, onMounted, ref } from 'vue'
import ReportHeader from '@/layouts/PageLayout.vue'
import { Statistics } from '@/widgets/Statistics'
import { DataRelevance } from '@/entities/DataRelevance'
import { VectorMap } from '@/entities/VectorMap'
import { ReportTarget } from '../../model/types/report'
import { useReport } from '../../model/hooks/useReport'
import { useReportMap } from '../../model/hooks/useReportMap'
import DataRange from '@/entities/DataRange/ui/DataRange.vue'
import { ProductType as ProductTypeEnum } from '@/entities/ProductTypes'
import { ActivityName } from '@/shared/consts/common'
import TrendSizes from '@/pages/Report/ui/ActivitySegment/TrendSizes.vue'
import Structure from '@/pages/Report/ui/ActivitySegment/Structure.vue'
import { useActivityType } from '@/pages/Report'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportLayout',
  props: {
    target: null,
    ending: null
  },
  emits: [
	'to'
],
  async setup(__props: any, { emit }) {

let __temp: any, __restore: any

const props = __props as {
	target: ReportTarget,
	ending?: string
};





const goTo = (id: number) => {
	emit('to', id)
}

const targetType = computed(() => props.target.type)

const {
	sidebarList,
	activitySegmentList,
	targetId,
	reportStore,
	locationsList,
	year
} = (
  ([__temp,__restore] = _withAsyncContext(() => useReport(targetType))),
  __temp = await __temp,
  __restore(),
  __temp
)

const {
	mapItemIsExpanded,
	hoverOnFeature,
	hoveredId
} = useReportMap(
	targetType,
	targetId.value
)

const { getActivityType } = useActivityType()

const chartsLegendNodeList = ref<NodeList | Array<undefined>>([])

function getAllChartsLegends() {
	chartsLegendNodeList.value = document.querySelectorAll('[data-name="chart-number"]')

	if (chartsLegendNodeList.value.length) {
		setChartsLegendsNumber(chartsLegendNodeList.value)
	}
}

function setChartsLegendsNumber(list) {
	list.forEach((chartLegend, index) => {
		chartLegend.innerHTML = index + 1
	})
}

onMounted(() => {
	getAllChartsLegends()
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "intro",
      "data-name": "anchor",
      class: _normalizeClass(["page-number-for-print", {'page-number-for-print--country': __props.target.type === 'country'}])
    }, [
      _createVNode(ReportHeader, {
        fixed: "",
        "sidebar-list": _unref(sidebarList),
        title: __props.target.name,
        "has-year-select": "",
        population: __props.target.population,
        "population-density": __props.target.density,
        "padding-top": "var(--header-height)"
      }, _createSlots({
        default: _withCtx(() => [
          _createVNode(_unref(VectorMap), {
            style: {"flex-shrink":"0"},
            type: __props.target?.type,
            "location-id": _unref(targetId),
            "hovered-id": _unref(hoveredId),
            onHoveredOnFeature: _unref(hoverOnFeature),
            onClickedOnFeature: goTo
          }, null, 8, ["type", "location-id", "hovered-id", "onHoveredOnFeature"]),
          _createVNode(_unref(Statistics), {
            "is-vertical": __props.target?.type === 'country'
          }, null, 8, ["is-vertical"]),
          _createVNode(_unref(DataRelevance), {
            class: "data-relevance",
            style: _normalizeStyle(`
              position:absolute;
              left: 0;
              bottom: -${__props.target?.type === 'region' ? '60' : '150'}px;
            `)
          }, null, 8, ["style"])
        ]),
        _: 2
      }, [
        (__props.target?.type !== 'region')
          ? {
              name: "footer",
              fn: _withCtx(() => [
                (_unref(locationsList))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["map-items", {'map-items__expend': _unref(mapItemIsExpanded)}])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(locationsList), (item) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: item.id,
                          onClick: ($event: any) => (_ctx.$emit('to', item.id)),
                          class: _normalizeClass(["map-items__item", { focused: item.id === _unref(hoveredId) }]),
                          onMousemove: ($event: any) => (hoveredId.value = item.id),
                          onMouseout: _cache[0] || (_cache[0] = ($event: any) => (hoveredId.value = undefined))
                        }, [
                          _createElementVNode("strong", null, _toDisplayString(String(item.id).length === 1 ? `0${item.id}` : item.id), 1),
                          _createTextVNode(" " + _toDisplayString(item.name.toUpperCase()), 1)
                        ], 42, _hoisted_2))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["sidebar-list", "title", "population", "population-density"])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("article", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activitySegmentList), (activity) => {
          return (_openBlock(), _createElementBlock("div", {
            key: activity.id,
            id: activity.id,
            "data-name": "anchor",
            class: "page-break"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                _createTextVNode(_toDisplayString(activity.name) + " " + _toDisplayString(__props.ending) + " ", 1),
                _createVNode(DataRange)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.children, (productType, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: productType.id
              }, [
                (!(productType.id === _unref(ProductTypeEnum).DISTILLATES && activity.id === _unref(ActivityName).RETAIL))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["page-break article__part", {'padding-for-logo': i !== 0 && !(productType.id === _unref(ProductTypeEnum).ALCOHOL && activity.id === _unref(ActivityName).RETAIL)}])
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h3", _hoisted_9, _toDisplayString(productType.name), 1)
                      ]),
                      _createElementVNode("div", {
                        "data-id": productType.id,
                        "data-name": "sub-anchor",
                        class: _normalizeClass(["page-number-for-print", {'page-number-for-print--first-in-activity': i === 0}])
                      }, [
                        _createVNode(Structure, {
                          target: __props.target,
                          data: _unref(getActivityType)(_unref(year), activity.id, productType.id),
                          type: activity.id,
                          "type-of-product": productType.id,
                          "instant-init": ""
                        }, null, 8, ["target", "data", "type", "type-of-product"]),
                        _createVNode(TrendSizes, {
                          "activity-type": activity.id,
                          "type-of-product": productType.id,
                          "instant-init": ""
                        }, null, 8, ["activity-type", "type-of-product"])
                      ], 10, _hoisted_10)
                    ], 2))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 8, _hoisted_5))
        }), 128))
      ])
    ])
  ])), [
    [_directive_loading, _unref(reportStore).getIsLoading]
  ])
}
}

})